import React, { Component } from 'react';
import {
    Dialog,
    DialogContent
} from '@material-ui/core/'

import { AxiosRequest } from '@apricityhealth/web-common-lib/utils/Axios';
import Config from '@apricityhealth/web-common-lib/Config';
import { Logger } from '@apricityhealth/web-common-lib';
import { getErrorMessage } from '@apricityhealth/web-common-lib/utils/getErrorMessage';

const log = new Logger();

export class DocusignDialog extends Component {
    constructor(props) {
        super(props);

        if (! props.patient ) throw new Error("patient property is required");
        if (! props.docusign ) throw new Error("docusign property is required");

        this.state = {
            docusignUrl: null,
            error: null
        };
    }

    onDocusignEvent(event) {
        log.info("onDocusignEvent:", event );
        if ( event.event === 'signing_complete') {
            this.props.onAccepted();
        } else if ( event.event === 'cancel' || event.event === 'decline') {
            this.props.onRejected();
        } else if ( event.event === 'viewing_complete' ) {
            this.props.onClose();
        }
    }

    componentDidMount() {
        // register docusignEvent callback to call into this dialog..
        this.props.appContext["docusignEvent"] = this.onDocusignEvent.bind(this);
        this.loadContent();
    }

    componentWillUnmount() {
        delete this.props.appContext["docusignEvent"];
    }

    async loadContent() {
        try {
            const { patient, docusign } = this.props;
            const getDocusignView = {
                url: Config.baseUrl + `${Config.pathPrefix}anon/authentication/getDocusignView`,
                method: 'post',
                data: {
                    ...docusign,
                    signerEmail: (patient.emails.find((e) => e.emailType === 'primary' && e.email ) || { email: ''}).email,
                    signerName: `${patient.firstName} ${patient.lastName}`,
                    termId: this.props.termId,
                    version: this.props.version,
                    userId: patient.userId,
                    onboardingUserId: (docusign.anchors || []).find((e) => e.recipientId === 2) ? patient.providerRegisteredId : undefined,
                    returnUrl: `${Config.patientClientUrl}?action=docusignEvent`          // redirect back to this client, it will have event=signing_complete
                }
            }

            log.info("getDocusignView request:", getDocusignView );
            const response = await AxiosRequest(getDocusignView);
            log.info("getDocusignView response:", response.data.url );
            this.setState({ progress: null, docusignUrl: response.data.url });

        } catch(err) {
            log.error("loadContent error:", err );
            this.setState({ progress: null, error: getErrorMessage(err) });
        }
    }

    render() {
        const { error, docusignUrl } = this.state;

        return <Dialog open={true} fullWidth={true} maxWidth='xl' onClose={this.props.onClose} fullScreen={this.props.appContext.isCompactDisplay()}>
            <DialogContent style={{ height: window.innerHeight * 0.85 }}>
                <span style={{color: 'red'}}>{error}</span>
                {docusignUrl && <iframe ref={(ref) => this.iFrame = ref} title='Docusign' src={docusignUrl} style={{width: '99%', height: window.innerHeight * 0.8, border: 0}} />}
            </DialogContent>
        </Dialog>
    }
};

